module.exports = __webpack_public_path__ + "static/media/dma.0bbfd1e2.svg";